<template>
<div>
    <div class="section-13">
        <div class="form-3-header-div-2">
            <div class="div-block-2319">
                <a href="#" class="w-inline-block"><img loading="lazy" src="@/assets/images/NewSelf_Logo.webp" alt="" class="image-715"></a>
                <div class="div-block-967">
                    <div class="text-block-152 top">STEP</div>
                    <div class="text-block-151">1 <span class="text-span-72">of</span> 3</div>
                    <div class="text-block-152 bottom">COMPLETE</div>
                </div>
            </div>
        </div>
        <div class="div-block-181">
            <div class="girl-div"></div>
        </div>
    </div>
    <section>
        <div class="step-form-wrap">
            <div class="steps-form-slide-1">
                <h1 class="heading-39-copy form"><span class="text-span-69">Hey! I&#x27;m Olivia.</span><br><strong>Let’s get you care - fast.</strong></h1>
                <p class="paragraph-79"><em>Skip the waiting room. Start your urgent care visit in minutes and get reviewed by a licensed provider today.</em></p>
                <div class="steps-main-div">
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/WeightSteps_QuizFlip.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/WeightSteps_QuizFlip-p-500.webp') + ' 500w, ' + require('@/assets/images/WeightSteps_QuizFlip-p-800.webp') + ' 800w, ' + require('@/assets/images/WeightSteps_QuizFlip.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Quick Intake</strong><br></div>
                                        <div class="process-step-sub-copy">Answer a few questions so we can review your symptoms and begin your urgent care visit.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">1</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">2 mins</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/StepsImage_video.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_video-p-500.webp') + ' 500w, ' + require('@/assets/images/StepsImage_video-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_video.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Record Video</strong><br></div>
                                        <div class="process-step-sub-copy">Recording a short video is required so the provider can review your condition safely.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">2</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">2 Mins</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/Doctor_newself.webp')" loading="lazy" sizes="(max-width: 755px) 100vw, 755px" :srcset="require('@/assets/images/Doctor_newself-p-500.webp') + ' 500w, ' + require('@/assets/images/Doctor_newself.webp') + ' 755w'" alt="" class="process-step-img-copy doc"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Provider Review</strong><br></div>
                                        <div class="process-step-sub-copy">A licensed clinician reviews your intake and determines the appropriate next steps.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">3</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">Today</div>
                        </div>
                    </div>
                    <div class="form-step">
                        <div class="process-box-copy">
                            <div class="process-flex-copy">
                                <div class="process-flex-left-copy">
                                    <div class="step-image-box-copy"><img :src="require('@/assets/images/StepsImage_logos.webp')" loading="lazy" sizes="(max-width: 1080px) 100vw, 1080px" :srcset="require('@/assets/images/StepsImage_logos-p-500.png') + ' 500w, ' + require('@/assets/images/StepsImage_logos-p-800.webp') + ' 800w, ' + require('@/assets/images/StepsImage_logos.webp') + ' 1080w'" alt="" class="process-step-img-copy"></div>
                                    <div class="process-box-text-div-copy">
                                        <div class="process-step-header-copy _1"><strong>Treatment &amp; Prescription</strong><br></div>
                                        <div class="process-step-sub-copy">Your treatment plan is finalized and prescriptions are sent to your local pharmacy if appropriate.</div>
                                    </div>
                                </div>
                                <div class="process-step-img2-div-copy">
                                    <div class="text-block-1469-copy">4</div>
                                </div>
                            </div>
                            <div class="stepstab-text-copy">Today</div>
                        </div>
                    </div>
                </div>
                <div class="text-block-149">All we will need is some basic info before we schedule your teledoc appointment.</div>
                <div class="div-block-1102 hide">
                    <div class="div-block-1101"><img loading="lazy" src="@/assets/images/icon_pencil2.svg" alt="" class="image-186">
                        <div class="text-block-221"><strong>Basic info</strong> (1 min)</div>
                    </div>
                    <div class="div-block-1101"><img loading="lazy" src="@/assets/images/icon_meds.svg" alt="" class="image-186">
                        <div class="text-block-221"><strong>Medical history</strong> (1 min)</div>
                    </div>
                    <div class="div-block-1101"><img loading="lazy" src="https://uploads-ssl.webflow.com/657b2233d6a286f5c9f3844c/662668e54d8e9bde78ad1cb3_icon_support.svg" alt="" class="image-186">
                        <div class="text-block-221 long"><strong>Meet with doctor online</strong></div>
                    </div>
                    <div class="div-block-1101"><img loading="lazy" src="@/assets/images/icon_best.svg" alt="" class="image-186">
                        <div class="text-block-221 long"><strong>Get meds at door in 3 Days</strong></div>
                    </div>
                </div>
                <a href="#" class="form-button-1 w-button" @click.prevent="startVisit">YES. LET&#x27;S DO IT!</a>
            </div>            
        </div>
    </section>
</div>
</template>

<script>
export default {
    name: 'urgentCareStart',
    methods: {
        startVisit() {
            //const orderId = this.$route.params.orderId;
            this.$router.push(`/home`);
        }
    }
}
</script>
